import {useEffect} from "react"


export const NotFound = () => {

    useEffect(() => {
        window.location.href = "https://www.chabochabo.net/errorpage/404.html"
    }, [])

    return(
        <div>            
        </div>
    )
}